import type { RouteType, RouteContext } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import type DashboardStore from "../shared/DashboardStore";

/**
 * Plant Operations dashboard. Two of its six tiles read
 * @intrasync/quality-control's `qc-metrics`, so it depends on the QC module
 * being wired — but degrades to per-tile failure states rather than an empty
 * page if it is not.
 */
const plantOpsRoute: RouteType = {
  name: "Plant Operations",
  title: "Plant Operations",
  path: "/dashboards/plant-operations",
  layout: "/app",
  group: "Dashboards",
  requiresAuth: true,
  requiresPermission: false,
  enableAutoFind: false,
  viewportCard: {
    header: {
      title: "Plant Operations",
      enableRefreshButton: true,
      component: () => import("./PlantOps.Header"),
    },
    body: {
      component: () => import("./PlantOps.Body"),
      grayBackground: true,
    },
  },
  onEnter: async ({ rootStore }: RouteContext) => {
    const store = (rootStore as RootStore & { dashboardStore?: DashboardStore })
      .dashboardStore;
    if (store) await store.loadData();
  },
};

export default plantOpsRoute;
